import { validEmail, validPassword } from './utilFunctions';

const getErrorTypeValue = (errorObj, key) => {
	if (errorObj?.hasOwnProperty(key)) {
		return errorObj[key][0] || "";
	}
	return "";
}

const registerCompany = () => ({
	globalError: null,
	errors: {},
	requestInProgress: false,
	getValidationFunction: function (key) {
		const validatorFunction = function(input) {
			const value = getErrorTypeValue(this.errors, key);
			return {
				valid: !value,
				errorMessage: value,
				input: value,
			};
		};
		
		return validatorFunction.bind(this);
	},
	revalidateInputs() {
		this.$dispatch('revalidate', { parentId: 'registerCompany'});
	},
	submit(e) {
		e.preventDefault();
		this.errors = {};
		this.globalError = null;

		const [
			distributor_company_name,
			distributor_company_address,
			distributor_company_tax_number,
			distributor_company_phone,
			distributor_company_email,
			distributor_name,
			distributor_email,
			distributor_phone,
			distributor_password,
			distributor_password_confirmation
		] = [...this.$el.querySelectorAll("input")].map(input => input.value);

		const company_logo_input = this.$el.querySelector(`input[type="file"]`);
		const company_logo = company_logo_input?.files[0];

		if (!(distributor_email && validEmail(distributor_email).valid)) {
			return;
		}

		if (!(distributor_password && validPassword(distributor_password))) {
			return;
		}

		if (distributor_password !== distributor_password_confirmation) {
			this.errors["distributor_password"] = ["A két jelszó nem egyezik meg."];
			this.errors["distributor_password_confirmation"] = ["A két jelszó nem egyezik meg."];
			this.revalidateInputs();
			return;
		}

		this.requestInProgress = true;
		let formData = new FormData();
		formData.append('distributor_company_name', distributor_company_name);
		formData.append('distributor_company_address', distributor_company_address);
		formData.append('distributor_company_tax_number', distributor_company_tax_number);
		formData.append('distributor_company_phone', distributor_company_phone);
		formData.append('distributor_company_email', distributor_company_email);
		formData.append('distributor_name', distributor_name);
		formData.append('distributor_email', distributor_email);
		formData.append('distributor_phone', distributor_phone);
		formData.append('distributor_password', distributor_password);
		formData.append('distributor_password_confirmation', distributor_password_confirmation);
		if (company_logo) {
			formData.append('company_logo', company_logo);
		}
		fetch("/api/register/company", {
			method:"POST",
			headers: {
				accept: "aplication/json",
			},
			body: formData
		})
		.then(resp => resp.json())
		.then(data => {
			if ('errors' in data) {
				this.errors = data.errors;
				this.revalidateInputs();
				return;
			}

			if (!('data' in data && 'status' in data.data && data.data.status == 'created'))
				throw new Error(data?.errors);

			this.errors = {};
			this.$dispatch('modalcloseid', {modalid: 'registermodal'});
			this.$dispatch('modalopenid', {modalid: 'successfulregister'});
			this.$root.reset();
		}).catch(err => {
			console.error(err);
			this.globalError = "Ismeretlen hiba történt a regisztráció közben."
			this.revalidateInputs();
		}).finally(() => {
			this.requestInProgress = false;
		});
	}
});

const registerDistributor = () => ({
	globalError: null,
	errors: {},
	getValidationFunction: function (key) {
		const validatorFunction = function(input) {
			const value = getErrorTypeValue(this.errors, key);
			return {
				valid: !value,
				errorMessage: value,
				input: value,
			};
		};
		
		return validatorFunction.bind(this);
	},
	revalidateInputs() {
		this.$dispatch('revalidate', { parentId: 'registerDistributor'});
	},
	submit(e) {
		e.preventDefault();
		this.errors = {};
		this.globalError = null;

		const [
			distributor_company_name,
			distributor_company_id,
			distributor_name,
			distributor_email,
			distributor_phone,
			distributor_password,
			distributor_password_confirmation
		] = [...this.$el.querySelectorAll("input")].map(input => input.value);

		if (!distributor_name ||
			!distributor_email ||
			!distributor_password ||
			!distributor_password_confirmation ||
			!validEmail(distributor_email).valid ||
			!validPassword(distributor_password)) {
				return;
		}

		if (!distributor_company_id) {
			this.errors["distributor_company_name"] = ["Válasszon ki egy cégnevet."];
			this.revalidateInputs();
			return;
		}

		if (distributor_password !== distributor_password_confirmation) {
			this.errors["distributor_password"] = ["A két jelszó nem egyezik meg."];
			this.errors["distributor_password_confirmation"] = ["A két jelszó nem egyezik meg."];
			this.revalidateInputs();
			return;
		}

		this.requestInProgress = true;
		let formData = new FormData();
		formData.append('distributor_company_id', distributor_company_id);
		formData.append('distributor_name', distributor_name);
		formData.append('distributor_email', distributor_email);
		formData.append('distributor_phone', distributor_phone);
		formData.append('distributor_password', distributor_password);
		formData.append('distributor_password_confirmation', distributor_password_confirmation);
		fetch("/api/register/distributor", {
			method:"POST",
			headers: {
				accept: "application/json",
			},
			body: formData
		})
		.then(resp => resp.json())
		.then(data => {
			console.log(data);
			if ('errors' in data) {
				this.errors = data.errors;
				return;
			}

			if (!('data' in data && 'status' in data.data && data.data.status == 'created'))
				throw new Error(data?.errors);

			this.errors = {};
			this.$dispatch('modalcloseid', {modalid: 'registermodal'});
			this.$dispatch('modalopenid', {modalid: 'successfulregister'});
			this.$root.reset();
		}).catch(err => {
			console.error(err);
			this.globalError = "Ismeretlen hiba történt a regisztráció közben."
		}).finally(() => {
			this.requestInProgress = false;
			this.revalidateInputs();
		});
	}
});

export { registerCompany, registerDistributor };
